import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";

type OrganizationState = {
  org: {
    plan: string;
    documentsPerMonth: string;
    addOns?: string | Array<string>;
    enableDiscrepancyDetection: boolean;
    enableAsyncReviewPage: boolean;
    enableAskDost: boolean;
    isImpersonatedUser: boolean;
    enabledModules: Array<string>;
    showModalOnBlockedModule: boolean;
    showAccountClassTagInDocList: boolean;
    manualDocumentStrategy: string | null;
    froce2FASetup: boolean;
    is2FAEnabled: boolean;
    isCompanyIdAssignableEnable?: boolean;
    isLLMExtraction: boolean;
    selfTrainingV2Enable: boolean;
    enableDiscrepancyV2: boolean;
    isTestingUser: boolean;
    reviewScreenV2Enable: boolean;
    hideDocumentlistingScreen: boolean;
    enableWorkflowTemplateExecution: boolean;
    enableEntityValidation: boolean;
    enableStandardization: boolean;
    createDate: string | null;
  };
};

const initialState: OrganizationState = {
  org: {
    plan: "",
    documentsPerMonth: "",
    addOns: "",
    enableDiscrepancyDetection: false,
    enableAsyncReviewPage: false,
    enableAskDost: false,
    isImpersonatedUser: false,
    enabledModules: [],
    showModalOnBlockedModule: false,
    showAccountClassTagInDocList: false,
    manualDocumentStrategy: null,
    froce2FASetup: false,
    is2FAEnabled: false,
    isCompanyIdAssignableEnable: false,
    isLLMExtraction: false,
    selfTrainingV2Enable: false,
    enableDiscrepancyV2: false,
    isTestingUser: false,
    reviewScreenV2Enable: false,
    hideDocumentlistingScreen: false,
    enableWorkflowTemplateExecution: false,
    enableEntityValidation: false,
    enableStandardization: false,
    createDate: null,
  },
};

const slice = createSlice({
  name: "Organization",
  initialState,
  reducers: {
    loginOrganizationAction(state, action) {
      let {
        organizationPlan,
        organizationDocumentsPerMonth,
        organizationAddOns,
        enableDiscrepancyDetection,
        enableAsyncReviewPage,
        enableAskDost,
        isImpersonatedUser,
        enabledModules,
        showModalOnBlockedModule,
        showAccountClassTagInDocList,
        manualDocumentStrategy,
        froce2FASetup,
        is2FAEnabled,
        isCompanyIdAssignableEnable,
        isLLMExtraction,
        selfTrainingV2Enable,
        enableDiscrepancyV2,
        isTestingUser,
        reviewScreenV2Enable,
        hideDocumentlistingScreen,
        enableWorkflowTemplateExecution,
        enableEntityValidation,
        enableStandardization,
        createDate,
      } = action.payload;
      state.org = {
        plan: organizationPlan,
        documentsPerMonth: organizationDocumentsPerMonth,
        addOns: organizationAddOns ?? "",
        enableDiscrepancyDetection,
        enableAsyncReviewPage,
        enableAskDost,
        isImpersonatedUser: isImpersonatedUser,
        enabledModules: enabledModules,
        showModalOnBlockedModule: showModalOnBlockedModule,
        showAccountClassTagInDocList: showAccountClassTagInDocList,
        manualDocumentStrategy: manualDocumentStrategy ?? null,
        froce2FASetup,
        is2FAEnabled,
        isCompanyIdAssignableEnable,
        isLLMExtraction,
        selfTrainingV2Enable,
        enableDiscrepancyV2,
        isTestingUser,
        reviewScreenV2Enable: reviewScreenV2Enable ?? false,
        hideDocumentlistingScreen: hideDocumentlistingScreen ?? false,
        enableWorkflowTemplateExecution: enableWorkflowTemplateExecution ?? false,
        enableEntityValidation: enableEntityValidation ?? false,
        enableStandardization: enableStandardization ?? false,
        createDate,
      };
    },
    logoutOrganizationAction(state) {
      state.org = {
        plan: "",
        documentsPerMonth: "",
        addOns: "",
        enableDiscrepancyDetection: false,
        enableAsyncReviewPage: false,
        enableAskDost: false,
        isImpersonatedUser: false,
        enabledModules: [],
        showModalOnBlockedModule: false,
        showAccountClassTagInDocList: false,
        manualDocumentStrategy: null,
        froce2FASetup: false,
        is2FAEnabled: false,
        isCompanyIdAssignableEnable: false,
        isLLMExtraction: false,
        selfTrainingV2Enable: false,
        enableDiscrepancyV2: false,
        isTestingUser: false,
        reviewScreenV2Enable: false,
        hideDocumentlistingScreen: false,
        enableWorkflowTemplateExecution: false,
        enableEntityValidation: false,
        enableStandardization: false,
        createDate: null,
      };
    },
    planUpdateAfterCheckout(state, action) {
      state.org = { ...state.org, plan: action.payload };
    },
    enable2faAction(state) {
      state.org = {
        ...state.org,
        is2FAEnabled: true,
      };
    },
    disable2faAction(state) {
      state.org = {
        ...state.org,
        is2FAEnabled: false,
      };
    },
  },
});

export default slice.reducer;

export const {
  loginOrganizationAction,
  logoutOrganizationAction,
  planUpdateAfterCheckout,
  enable2faAction,
  disable2faAction,
} = slice.actions;

export const loginOrganization = (state: any) => {
  return async () => {
    dispatch(loginOrganizationAction(state));
  };
};

export const logoutOrganization = () => {
  return async () => {
    dispatch(logoutOrganizationAction());
  };
};

export const planUpdate = (state: any) => {
  return async () => {
    dispatch(planUpdateAfterCheckout(state));
  };
};

export const enable2fa = () => {
  return async () => {
    dispatch(enable2faAction());
  };
};

export const disable2fa = () => {
  return async () => {
    dispatch(disable2faAction());
  };
};
